<template>
    <div>
        <div class="container">
          <div class="consent-content">
            <h3 class="p1">PRC Addendum</h3>
          </div>
            <div class="consent-content">
                <h3 class="p1">K11 LP / KLUB 11</h3>
            </div>

            <div class="consents-content" id="k11" v-if="!hideK11">
                <p><strong>Please tick the box(es) below to acknowledge your consent.</strong></p>
                <div class="form-content">
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_1_AGREE') }"
                                 v-on:click="setPIPL('CNPIPL_1_AGREE')"></div>
                            <p>I, as the parent or legal guardian (where applicable) of the Minor, understand the above and all the contents of the <a
                                    target="_blank" href="https://klub-11.com/privacy-policy/">K11 LP’s Privacy Policy Statement</a>, the <a target="_blank" href="https://www.nwd.com.hk/privacy-policy">
                                    New World Group’s Privacy Policy Statement</a>, the <a
                                    target="_blank" href="https://media.k11.com/general_assets/KLUB_11_PICS_EN.pdf">PICS</a>, the <a
                                    target="_blank" href="https://media.k11.com/general_assets/KLUB_11_PRC_Addendum_EN_incl._Minor_Rules___Annex_A.pdf">Addendum
                                and Annex A</a> to the Addendum, and consent to the collection, use and processing of the Minor’s personal data in connection with the Purposes for Minors set out above.</p>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_1_GROUP') }"
                                 v-on:click="setPIPL('CNPIPL_1_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>By ticking this box, I, as the parent or legal guardian (where applicable) of the Minor, 
                                    also consent to all of the following in processing the Minor’s personal data. 
                                    I understand that I may disagree with any of the items below by unticking the individual boxes below,
                                    but K11 LP may not be able to offer to me and/or the Minor certain goods/services without my relevant consent.
                                </p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('CNPIPL_3_SENSITIVE') }"
                                                 v-on:click="setPIPL('CNPIPL_3_SENSITIVE')"></div>
                                            <p>I consent to the collection and processing of the Minor’s sensitive
                                               personal data in connection with the Purposes for Minors set out above.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('CNPIPL_4_TRANSFER') }"
                                                 v-on:click="setPIPL('CNPIPL_4_TRANSFER')"></div>
                                            <p><span class="TextRun SCXW9822291 BCX0" lang="EN-US" xml:lang="EN-US"
                                                    data-contrast="auto"><span class="NormalTextRun SCXW9822291 BCX0">I consent to the transfer of the Minor&rsquo;s personal data (including </span></span><span
                                                    class="TextRun MacChromeBold SCXW9822291 BCX0" lang="EN-US"
                                                    xml:lang="EN-US" data-contrast="auto"><span
                                                    class="NormalTextRun SCXW9822291 BCX0">sensitive personal data</span></span><span
                                                    class="TextRun SCXW9822291 BCX0" lang="EN-US" xml:lang="EN-US"
                                                    data-contrast="auto"><span class="NormalTextRun SCXW9822291 BCX0">) to outside Mainland China. &nbsp;</span></span><span
                                                    class="EOP SCXW9822291 BCX0"
                                                    data-ccp-props="{&quot;134245417&quot;:true,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:975,&quot;335559991&quot;:270}">&nbsp;</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('CNPIPL_5_3RD') }"
                                                 v-on:click="setPIPL('CNPIPL_5_3RD')"></div>
                                            <p><span class="TextRun SCXW17587838 BCX0" lang="EN-US" xml:lang="EN-US"
                                                     data-contrast="auto"><span class="NormalTextRun SCXW17587838 BCX0">I consent to </span><span
                                                    class="NormalTextRun SCXW17587838 BCX0">providing</span><span
                                                    class="NormalTextRun SCXW17587838 BCX0"> the Minor&rsquo;s personal data (including </span></span><span
                                                    class="TextRun MacChromeBold SCXW17587838 BCX0" lang="EN-US"
                                                    xml:lang="EN-US" data-contrast="auto"><span
                                                    class="NormalTextRun SCXW17587838 BCX0">sensitive personal data</span></span><span
                                                    class="TextRun SCXW17587838 BCX0" lang="EN-US" xml:lang="EN-US"
                                                    data-contrast="auto"><span class="NormalTextRun SCXW17587838 BCX0">) to third parties</span><span
                                                    class="NormalTextRun SCXW17587838 BCX0">.&nbsp;&nbsp;</span></span><span
                                                    class="EOP SCXW17587838 BCX0"
                                                    data-ccp-props="{&quot;134245417&quot;:true,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:975,&quot;335559991&quot;:270}">&nbsp;</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('CNPIPL_2_GROUP') }"
                                 v-on:click="setPIPL('CNPIPL_2_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>By ticking this box, I, as the parent or legal guardian (where applicable) of the Minor, also consent to the following in processing the Minor&rsquo;s
                                    personal data.</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('CNPIPL_7_DIRECT_OPTIN') }"
                                                 v-on:click="setPIPL('CNPIPL_7_DIRECT_OPTIN')"></div>
                                            <p>I consent to receive direct marketing from K11 LP
                                                and its use of the Minor&rsquo;s personal data for direct marketing
                                                purposes.</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('CNPIPL_6_OPTIN') }"
                                                 v-on:click="setPIPL('CNPIPL_6_OPTIN')"></div>
                                            <p>I consent to the sharing of the Minor&rsquo;s personal data by K11
                                                LP with NWG&rsquo;s Affiliates and Marketing
                                                Partners for direct marketing and cross marketing purposes in Hong Kong
                                                and outside Hong Kong.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-content-bottom">
                    <p>
                        If I, as the parent or legal guardian (where applicable) of the Minor, 
                        do not agree with the contents of <a target="_blank" href="https://klub-11.com/privacy-policy/">K11 LP&rsquo;s Privacy Policy Statement</a>, 
                        the <a target="_blank" href="https://www.nwd.com.hk/privacy-policy">New World Group&rsquo;s Privacy Policy Statement</a>, 
                        the <a target="_blank" href="https://media.k11.com/general_assets/KLUB_11_PICS_EN.pdf">PICS</a>, 
                        the <a target="" href="https://media.k11.com/general_assets/KLUB_11_PRC_Addendum_EN_incl._Minor_Rules___Annex_A.pdf ">Addendum and Annex A</a> to the Addendum, I understand that I can contact 
                        K11 LP&rsquo;s Personal Data Privacy Officer at 4/F, Tsim Sha Tsui Centre, 
                        No.66 Mody Road, Tsim Sha Tsui, Kowloon, Hong Kong (marked Confidential) 
                        and with the name of K11 LP to understand the Minor&rsquo;s choices and 
                        rights and make appropriate arrangements.
                    </p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="consent-content">
                <h3 class="p1">K Dollar Program</h3>
            </div>

            <div class="consents-content" id="kdp">
                <p><strong>Please tick the box(es) below to acknowledge your consent.</strong></p>
                <p>&nbsp;</p>
                <div class="form-content">
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_1_AGREE') }"
                                 v-on:click="setPIPL('KDP_CNPIPL_1_AGREE')"></div>
                            <p>I, as the parent or legal guardian (where applicable) of the Minor, understand the above
                                and all the contents of the <a target="_blank" href="https://hk.krewards.com/privacy-policy/">Privacy
                                    Policy Statement</a>, the <a target="_blank" href="https://hk.krewards.com/pipl-prc-addendum/">Addendum</a>,
                                <a target="_blank" href="https://hk.krewards.com/pipl-annexa/">Annex A</a> to the Addendum and the <a
                                        target="_blank" href="https://hk.krewards.com/personal-information-collection-statement/">PICS</a>,
                                and consent to the collection, use and processing of the Minor&rsquo;s personal data in
                                connection with the Purposes for Minors set out above.</p>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_1_GROUP') }"
                                 v-on:click="setPIPL('KDP_CNPIPL_1_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>By ticking this box, I, as the parent or legal guardian (where applicable) of the
                                    Minor, also consent to all of the following in processing the Minor&rsquo;s personal
                                    data. &nbsp;I understand that I may disagree with any of the items below by
                                    unticking the individual boxes below, but MPNCL may not be able to offer to me
                                    and/or the Minor certain goods/services without my relevant consent.</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('KDP_CNPIPL_3_SENSITIVE') }"
                                                 v-on:click="setPIPL('KDP_CNPIPL_3_SENSITIVE')"></div>
                                            <p>I consent to the collection and processing of the Minor&rsquo;s sensitive
                                                personal data in connection with the Purposes for Minors set out above.</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('KDP_CNPIPL_4_TRANSFER') }"
                                                 v-on:click="setPIPL('KDP_CNPIPL_4_TRANSFER')"></div>
                                            <p>I consent to the transfer of the Minor&rsquo;s personal data (including
                                                sensitive personal data) to outside Mainland China</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('KDP_CNPIPL_5_3RD') }"
                                                 v-on:click="setPIPL('KDP_CNPIPL_5_3RD')"></div>
                                            <p>I consent to providing the Minor&rsquo;s personal data (including
                                                sensitive personal data) to third parties.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="consent-item">
                        <div class="flex">
                            <div class="check-box-container" :class="{ active: getPipl('KDP_CNPIPL_2_GROUP') }"
                                 v-on:click="setPIPL('KDP_CNPIPL_2_GROUP')"></div>
                            <div class="child-container">
                                <div class="line"></div>
                                <p>By ticking this box, I, as the parent or legal guardian (where applicable) of the
                                    Minor, also consent to the following in processing the Minor&rsquo;s personal
                                    data.</p>
                                <div class="child-check-box-container">
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('KDP_CNPIPL_7_DIRECT_OPTIN') }"
                                                 v-on:click="setPIPL('KDP_CNPIPL_7_DIRECT_OPTIN')"></div>
                                            <p>I consent to receive direct marketing from MPNCL and its use of the Minor&rsquo;s
                                                personal data for direct marketing purposes.</p>
                                        </div>
                                    </div>
                                    <div class="child-consent-item">
                                        <div class="flex">
                                            <div class="check-box-container child-checkbox"
                                                 :class="{ active: getPipl('KDP_CNPIPL_6_OPTIN') }"
                                                 v-on:click="setPIPL('KDP_CNPIPL_6_OPTIN')"></div>
                                            <p>I consent to the sharing of the Minor&rsquo;s personal data by MPNCL with
                                                Affiliates and Marketing Partners for direct marketing and cross
                                                marketing purposes in Hong Kong and outside Hong Kong.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-content-bottom">
                    <p>If I, as the parent or legal guardian (where applicable) of the Minor, do not agree with the
                        contents of the <a target="_blank" href="https://hk.krewards.com/privacy-policy/">Privacy Policy Statement</a>, the <a target="_blank" href="https://hk.krewards.com/pipl-prc-addendum/">Addendum</a>, <a target="_blank" href="https://hk.krewards.com/pipl-annexa/">Annex A</a> to the Addendum and the <a target="_blank" href="https://hk.krewards.com/personal-information-collection-statement/">PICS</a>, I
                        understand that I can contact MPNCL&rsquo;s Personal Data Privacy Officer at 4/F, Tsim Sha Tsui
                        Centre, No.66 Mody Road, Tsim Sha Tsui, Kowloon, Hong Kong (marked Confidential) and with the
                        name of Missions Points Network Company Limited or by email to <a
                                target="_blank" href="mailto:privacy@krewards.com">privacy@krewards.com</a> to understand the Minor&rsquo;s
                        choices and rights and make appropriate arrangements.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";
import pipl from "@/views/pipl.vue";

export default {
    name: "piplprompt",
    props: [],
    data() {
        return {
            hideK11: false,
        }
    },
    components: {},
    created() {
    },
    mounted() {
        this.hideK11 = !this.$store.state.k11VipCode.startWith('01') && this.isWechat
    },
    computed: {
        ...mapGetters(['getPipl', 'isWechat']),
    },
    methods: {
        ...mapMutations(['setPIPL']),
    },
};
</script>


<style scoped>
@font-face {
    font-family: "Proxima Nova";
    src: url("[regular]");
    font-weight: 400;
}

@font-face {
    font-family: "Proxima Nova";
    src: url("[semi-bold]");
    font-weight: 600;
}

@font-face {
    font-family: "Marcellus";
    src: url("[marcellus-regular]");
    font-weight: 400;
}

body {
    margin: 0px;
    color: #504e49;
    font-family: "Proxima Nova";
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
}

.container {
    padding: 0px 20px;
}

h2 {
    letter-spacing: 0.2px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    margin: 0px 0px 4px;
    font-family: "Marcellus";
}

p {
    margin: 0px;
}

h6 {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    margin: 0px 0px 8px;
    color: #504e49;
}

.flex {
    display: flex;
    flex: 1 0 100%;
}

a {
    color: #baa16f;
    text-decoration: underline;
}

.consents-content {
    font-size: 14px;
    line-height: 16px;
    //color: #928f89;
}

.form-content {
    padding: 16px 0px 0px;
}

.consent-item,
.consent-content {
    margin-bottom: 24px;
}

.child-consent-item {
    margin-top: 12px;
}

.consent-item p {
    margin-left: 8px;
}

.check-box-container {
    border: 2px solid #cecdca;
    border-radius: 8px;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
}

.check-box-container.active {
    background-color: gray;
}

.check-box-container.active::before {
    content: "";
    display: block;
    transform: rotate(45deg);
    height: 11px;
    width: 5px;
    border-bottom: 2px solid white;
    border-right: 2px solid white;
    margin-left: 6px;
    margin-top: 2px;
}

.child-check-box-container {
    padding-top: 12px;
}

.child-container {
    position: relative;
}

.line {
    position: absolute;
    width: 1px;
    background: #e7e6e4;
    height: calc(100% - 48px);
    margin-top: 48px;
    left: -20px;
}

.form-content-bottom {
    color: #504E49;
    padding-bottom: 24px;
    font-size: 16px;
    line-height: 24px;
}
</style>
